/**
 * PageContainer - Shared page-shell layout wrapper
 * 
 * Single consistent max-width (max-w-6xl / 1152px), centering,
 * horizontal padding, and vertical padding (py-8).
 * Every page uses the same width — no variants.
 */

export function PageContainer({ 
  children, 
  className = ''
}) {
  return (
    <div className={`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 print:max-w-none print:px-0 print:py-0 ${className}`}>
      {children}
    </div>
  );
}

export default PageContainer;
